import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useVerificationActions = () => {
  const queryClient = useQueryClient();

  const approveVerification = useMutation({
    mutationFn: async ({ verificationId, adminId }: { verificationId: string; adminId: string }) => {
      const { data, error } = await supabase.rpc('approve_verification', {
        p_verification_id: verificationId,
        p_admin_id: adminId,
      });
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-verifications'] });
      queryClient.invalidateQueries({ queryKey: ['admin-pending-activities'] });
      toast.success('Verificação aprovada com sucesso!');
    },
    onError: (error) => {
      console.error('Erro ao aprovar verificação:', error);
      toast.error('Erro ao aprovar verificação. Tente novamente.');
    },
  });

  const rejectVerification = useMutation({
    mutationFn: async ({ 
      verificationId, 
      adminId, 
      reason 
    }: { 
      verificationId: string; 
      adminId: string; 
      reason: string;
    }) => {
      const { data, error } = await supabase.rpc('reject_verification', {
        p_verification_id: verificationId,
        p_admin_id: adminId,
        p_reason: reason,
      });
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-verifications'] });
      queryClient.invalidateQueries({ queryKey: ['admin-pending-activities'] });
      toast.success('Verificação rejeitada.');
    },
    onError: (error) => {
      console.error('Erro ao rejeitar verificação:', error);
      toast.error('Erro ao rejeitar verificação. Tente novamente.');
    },
  });

  return {
    approveVerification,
    rejectVerification,
  };
};
